<template>
  <div>
    <NotificationModal
      v-if="notification"
      v-model="notificationModalState"
      :notification="notification"
      :isBaseModal="true"
      :isPopupModal="false"
      @close="modalClose"
    >
    </NotificationModal>
  </div>
</template>

<script>

import NotificationModal from '#js_site/components/Notification/NotificationModal';

export default {
  name: 'EventPopupComponent',
  components: { NotificationModal },
  props: {},
  data() {
    return {
      notificationModalState: false,
      notification: null,
    }
  },
  computed: {},
  watch: {},
  methods: {
    modalClose() {
      this.notificationModalState = false;
      this.notification = null;
    }
  },
  mounted() {
    this.$eventHub.$on('EventPopupModalOpen', (event) => {
      this.$store.dispatch('popups/loadPopups')
        .then(() => {
          const notification = this.$store.getters['popups/getByEvent'](event);

          if (notification) {
            this.notification = {
              id: notification.id,
              event: notification.event,
              data: notification
            };

            this.$nextTick(() => {
              this.notificationModalState = true;
            });
          }
        });
    });
  }
}
</script>

<style scoped>

</style>
